import { OrderDTO } from 'models/order';

export function salesPersonTemplate(order: OrderDTO) {
  const { salesPerson } = order;

  return (salesPerson?.firstName && salesPerson?.lastName) ? `${salesPerson.firstName.charAt(0).toUpperCase()}. ${salesPerson.lastName}` : '';
}
